export const SITE_NAME = "rowrowrow.blog";
export const SITE_URL = "https://rowrowrow.blog";

/**
 * Individual directory entry pages (/directory/<category>/<slug>) are one
 * sentence plus an outbound link. ~550 of them made up most of the sitemap
 * and earned ~150 Google impressions in 28 days, so they are noindex,follow
 * and out of the sitemap. The category hubs and /clubs map that list the
 * same entries stay indexed. Flip to true to revert.
 */
export const INDEX_DIRECTORY_ENTRIES = false;
export const SITE_DESCRIPTION =
  "Your comprehensive directory of rowing resources - manufacturers, communities, training tools, events, and more.";

export const CATEGORIES = [
  { name: "Manufacturers", slug: "manufacturers", icon: "factory", description: "Rowing shell and equipment manufacturers" },
  { name: "Communities", slug: "communities", icon: "users", description: "Online communities and forums for rowers" },
  { name: "Classifieds", slug: "classifieds", icon: "tag", description: "Buy and sell rowing equipment" },
  { name: "Training", slug: "training", icon: "dumbbell", description: "Training tools, apps, and coaching resources" },
  { name: "Organizations", slug: "organizations", icon: "landmark", description: "Governing bodies and associations" },
  { name: "Media", slug: "media", icon: "newspaper", description: "News, podcasts, and rowing media" },
  { name: "Events", slug: "events", icon: "trophy", description: "Regattas and rowing events", href: "/events" },
  { name: "Equipment", slug: "equipment", icon: "wrench", description: "Ergometers, apparel, and accessories" },
  { name: "Clubs", slug: "clubs", icon: "anchor", description: "Rowing clubs and boathouses across the US", href: "/clubs" },
  { name: "Books & Films", slug: "books-films", icon: "book-open", description: "Books, films, and documentaries about rowing", href: "/books-films" },
] as const;

export type CategorySlug = (typeof CATEGORIES)[number]["slug"];
